/* erzeugt aus preview/ (shop-port.js) */
/* OTHERSPORTS · Homepage Interim – Preview
   Reveal, Navigation, Tabs, Marquee, kleine Einmal-Animationen, Tracking-Stub. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  root.classList.add('js');

  // Vorschau: Animationen laufen immer, damit das Design beurteilbar ist – abschaltbar mit ?motion=0.
  // Im Theme-Port hier wieder window.matchMedia('(prefers-reduced-motion: reduce)').matches verwenden.
  var reducedMotion = new URLSearchParams(window.location.search).get('motion') === '0';
  if (reducedMotion) root.classList.add('no-motion');

  /* Tracking -----------------------------------------------------------------
     Jedes Ereignis geht (1) in den dataLayer, (2) als Shopify-Customer-Event „os_<name>“ an die
     Customer-Events-Pixel (dort leitet ein eigenes Pixel an GA4 weiter – siehe docs/ga4-ereignisse.md;
     Einwilligung regelt Shopify über die Pixel-Berechtigung) und (3) direkt an gtag, falls GA4 auf der
     Seite geladen ist. In der Vorschau bleibt es beim dataLayer + Konsolenausgabe. */
  window.dataLayer = window.dataLayer || [];
  window.osTrack = function (event, payload) {
    var daten = payload || {};
    var entry = Object.assign({ event: event }, daten);
    window.dataLayer.push(entry);
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('os_' + event, daten); } catch (err) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'os_' + event, daten); } catch (err) {}
    if (window.console && console.debug) console.debug('[osTrack]', entry);
  };

  doc.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el) return;
    var payload = {};
    if (el.dataset.trackProdukt) payload.produkt = el.dataset.trackProdukt;
    if (el.dataset.trackZiel) payload.ziel = el.dataset.trackZiel;
    window.osTrack(el.dataset.track, payload);
  });

  /* Scroll-Reveal -----------------------------------------------------------
     Gruppen ([data-reveal-group="ms"]) staffeln ihre Kinder. */
  doc.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    var step = parseInt(group.getAttribute('data-reveal-group'), 10) || 80;
    group.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      el.style.setProperty('--reveal-delay', (i * step) + 'ms');
    });
  });

  function onceVisible(elements, threshold, callback) {
    if (!('IntersectionObserver' in window) || reducedMotion) {
      elements.forEach(callback);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        callback(entry.target);
      });
    }, { threshold: threshold, rootMargin: '0px 0px -5% 0px' });
    elements.forEach(function (el) { io.observe(el); });
  }

  onceVisible(Array.from(doc.querySelectorAll('[data-reveal]')), 0.2, function (el) { el.classList.add('is-visible'); });
  /* Wisch-Reihen: alle Karten einer Reihe erscheinen gemeinsam, sobald die Reihe im Blick ist – beim Wischen
     rutscht dann keine Karte mehr von unten herein (Ronny 17.10.) */
  onceVisible(Array.from(doc.querySelectorAll('.os-slider, .os-otiles, .os-lineup, .os-reviews__list')), 0.05, function (reihe) {
    reihe.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  });
  /* Zurück-Taste: wird die Seite beim Zurückspringen neu aufgebaut, landet der Browser oft oben –
     die Scrollposition wird deshalb beim Verlassen gemerkt und beim Zurückkommen wiederhergestellt (Ronny 17.10.).
     Seit 20.10. zusätzlich: offene Produkt-Reiter (Ella-Akkordeon, z. B. „Trainingsmaterialien und -Videos“) und der
     zuletzt angeklickte Link – beim Zurückkommen gehen die Reiter wieder auf und der Link steht an derselben Stelle
     (ohne das war die Seite mit geschlossenen Reitern kürzer, die alte Höhe zeigte auf etwas anderes). */
  try {
    var merkKey = 'os-scroll:' + window.location.pathname;
    var zuletzt = null;
    doc.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var reiter = a.closest('.tab-content[id]');
      zuletzt = { tab: reiter ? reiter.id : '', i: reiter ? Array.prototype.indexOf.call(reiter.querySelectorAll('a[href]'), a) : -1, top: Math.round(a.getBoundingClientRect().top) };
    }, true);
    window.addEventListener('pagehide', function () {
      var offen = Array.prototype.map.call(doc.querySelectorAll('.tab-content[id] > .toggle-title > .toggleLink.is-open'), function (t) { return t.closest('.tab-content').id; });
      window.sessionStorage.setItem(merkKey, JSON.stringify({ y: Math.round(window.scrollY), offen: offen, link: zuletzt }));
    });
    var navEintrag = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var zurueck = navEintrag ? navEintrag.type === 'back_forward' : !!(window.performance && performance.navigation && performance.navigation.type === 2);
    var gemerkt = window.sessionStorage.getItem(merkKey);
    if (zurueck && gemerkt) {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      var daten;
      try { daten = JSON.parse(gemerkt); } catch (e2) { daten = null; }
      if (!daten || typeof daten !== 'object') daten = { y: parseInt(gemerkt, 10) || 0 };
      var oeffne = function () {
        (daten.offen || []).forEach(function (id) {
          var reiter = doc.getElementById(id);
          var t = reiter && reiter.querySelector('.toggle-title > .toggleLink');
          var inhalt = reiter && reiter.querySelector('.toggle-content');
          if (!t || !inhalt || t.classList.contains('is-open')) return;
          t.classList.add('is-open');
          inhalt.style.display = 'block';
        });
      };
      var springe = function () {
        oeffne();
        var l = daten.link, a = null;
        if (l && l.tab && l.i >= 0) { var r = doc.getElementById(l.tab); if (r) a = r.querySelectorAll('a[href]')[l.i] || null; }
        if (a && a.offsetParent !== null) window.scrollTo(0, Math.max(0, a.getBoundingClientRect().top + window.scrollY - l.top));
        else window.scrollTo(0, daten.y || 0);
      };
      springe();
      window.addEventListener('load', function () { springe(); window.setTimeout(springe, 120); window.setTimeout(springe, 500); window.setTimeout(springe, 1200); });
    }
  } catch (err) {}
  onceVisible(Array.from(doc.querySelectorAll('[data-dock]')), 0.5, function (el) { el.classList.add('is-docked'); });
  onceVisible(Array.from(doc.querySelectorAll('[data-flow]')), 0.5, function (el) { el.classList.add('is-drawn'); });
  onceVisible(Array.from(doc.querySelectorAll('[data-mini]')), 0.5, function (el) { el.classList.add('is-typed'); });

  /* Desktop-Navigation: Dropdowns per Klick/Tastatur ------------------------ */
  var subItems = Array.from(doc.querySelectorAll('.os-nav__item--has-sub'));
  function closeSubs(except) {
    subItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('.os-nav__link').setAttribute('aria-expanded', 'false');
    });
  }
  subItems.forEach(function (item) {
    var btn = item.querySelector('.os-nav__link');
    btn.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      closeSubs(item);
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    item.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeSubs();
      btn.focus();
    });
  });
  doc.addEventListener('click', function (e) {
    if (!e.target.closest('.os-nav__item--has-sub')) closeSubs();
  });

  /* Mobile-Navigation ------------------------------------------------------- */
  var burger = doc.querySelector('.os-header__burger');
  var mobileNav = doc.getElementById('os-mobile-nav');
  function setMobileNav(open) {
    if (!burger || !mobileNav) return;
    mobileNav.hidden = !open;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    burger.querySelector('use').setAttribute('href', open ? '#i-close' : '#i-menu');
  }
  if (burger) {
    burger.addEventListener('click', function () { setMobileNav(mobileNav.hidden); });
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-nav]')) setMobileNav(false);
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mobileNav.hidden) { setMobileNav(false); burger.focus(); }
    });
    window.matchMedia('(min-width: 1120px)').addEventListener('change', function () { setMobileNav(false); });
  }

  /* Tabs (S6) ---------------------------------------------------------------- */
  doc.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var tabEls = Array.from(tabs.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabEls.forEach(function (t) {
        var active = t === tab;
        var panel = doc.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      if (focus) tab.focus();
      window.osTrack('tab_training', { tab: tab.dataset.tab });
    }
    tabEls.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabEls[(i + 1) % tabEls.length];
        if (e.key === 'ArrowLeft') next = tabEls[(i - 1 + tabEls.length) % tabEls.length];
        if (e.key === 'Home') next = tabEls[0];
        if (e.key === 'End') next = tabEls[tabEls.length - 1];
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  });

  /* Logo-Marquee (alle Breiten): Liste duplizieren, bei Berührung pausieren ---- */
  var viewport = doc.querySelector('.os-logos__viewport');
  if (viewport && !reducedMotion) {
    var track = viewport.querySelector('.os-logos__track');
    Array.from(track.children).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    var pause = function () { viewport.classList.add('is-paused'); };
    var resume = function () { viewport.classList.remove('is-paused'); };
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('touchend', resume);
    viewport.addEventListener('touchcancel', resume);
  }

  /* Preview-Hinweis für Seiten, die es noch nicht gibt ----------------------- */
  var toast = doc.getElementById('os-toast');
  var toastTimer = null;
  window.osToast = function (message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3600);
  };
  /* Hinweis statt Funktion (z. B. Interview, das noch nicht veröffentlicht ist) */
  doc.addEventListener('click', function (e) {
    var el = e.target.closest('[data-os-toast]');
    if (!el) return;
    e.preventDefault();
    window.osToast(el.getAttribute('data-os-toast'));
  });
  doc.addEventListener('click', function (e) {
    var el = e.target.closest('[data-preview-missing]');
    if (!el) return;
    e.preventDefault();
    window.osToast('Preview: ' + el.getAttribute('data-preview-missing'));
  });
})();

/* Suche (Runde 10): Suchfeld unter der Kopfzeile ein- und ausblenden; Enter schickt an die Shop-Suche */
(function () {
  var doc = document;
  var box = doc.getElementById('os-suche');
  if (!box) return;
  var feld = box.querySelector('.os-suche__feld');
  var knoepfe = Array.prototype.slice.call(doc.querySelectorAll('[data-os-suche-open]'));
  function setze(offen) {
    box.hidden = !offen;
    knoepfe.forEach(function (k) { k.setAttribute('aria-expanded', offen ? 'true' : 'false'); });
    if (offen) window.setTimeout(function () { feld.focus(); }, 30);
  }
  knoepfe.forEach(function (k) {
    k.addEventListener('click', function (e) { e.preventDefault(); setze(box.hidden); });
  });
  box.querySelector('[data-os-suche-close]').addEventListener('click', function () { setze(false); knoepfe[0] && knoepfe[0].focus(); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) { setze(false); knoepfe[0] && knoepfe[0].focus(); } });
  doc.addEventListener('click', function (e) {
    if (box.hidden) return;
    if (box.contains(e.target) || e.target.closest('[data-os-suche-open]')) return;
    setze(false);
  });
})();

/* Physio-Siegel: Antippen zeigt die empfehlenden Praxen (Ronny 17.10.) */
(function () {
  var toggle = document.querySelector('[data-seal-toggle]');
  if (!toggle) return;
  var namen = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!namen) return;
  toggle.addEventListener('click', function () {
    var offen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!offen));
    namen.hidden = offen;
  });
})();
